import {IntlShape} from 'react-intl';
import {DateTime} from 'luxon';

export interface PeriodeOption {
  label: string;
  moisApi: string;
}

/**
 * Le back n'expose aucune date de création de service (la procédure legacy
 * `Prestations_Get` ne la projette pas) : le sélecteur remonte donc une
 * fenêtre glissante de mois, plutôt qu'une liste dérivée d'une vraie borne.
 */
export const NOMBRE_MOIS_PERIODE = 6;

/** Mois courant en tête, jusqu'à `count` mois en arrière. */
export const genererPeriodesDisponibles = (intl: IntlShape, count: number): PeriodeOption[] =>
  Array.from({length: count}, (_, index) => {
    const date = DateTime.now().minus({months: index}).toJSDate();
    const brut = intl.formatDate(date, {month: 'long', year: 'numeric'});
    return {
      label: brut.charAt(0).toUpperCase() + brut.slice(1),
      moisApi: DateTime.fromJSDate(date).toFormat('yyyy-MM'),
    };
  });
